<div class="dialog__wrapper">
  <form [formGroup]="formArray" (ngSubmit)="handleFormSubmit()">
    <div class="dialog__header" mat-dialog-title>
      <h4 class="dialog__title">Pending Authorisations</h4>
      <button mat-dialog-close mat-icon-button>
        <mat-icon mat-button class="icon" fontIcon="close"></mat-icon>
      </button>
    </div>
    <mat-dialog-content>
      <div>
        <table mat-table [dataSource]="dataSource$ | async">
          <ng-container matColumnDef="senderIdText">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Sender ID Text</th>
            <td mat-cell *matCellDef="let element">{{ element.senderIdText }}</td>
          </ng-container>
          <ng-container matColumnDef="opa">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>OPA</th>
            <td mat-cell *matCellDef="let element">{{ element.organisationName }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <div class="radio-select__container">
                <mat-radio-group aria-label="Pending opas authorisation" [formControl]="getFormArrayControl(i)">
                  <mat-radio-button [value]="OPAStatus.Authorised">Approve</mat-radio-button>
                  <mat-radio-button [value]="OPAStatus.NotAuthorised">Refuse</mat-radio-button>
                </mat-radio-group>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>

          <tr *matNoDataRow>
            <td colspan="3">Pending Authorisations list is empty</td>
          </tr>
        </table>

        <div class="dialog__spinner">
          <div *comSpinner="isFetching; color: 'primary'; diameter: 30"></div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-raised-button type="submit" [disabled]="formArray.pristine">Confirm</button>
      <button mat-flat-button (click)="handleClose()" type="button" class="button--secondary button--pad-right">Close</button>
    </mat-dialog-actions>
  </form>
</div>
